<template>
	<main>
		<v-select
			:options="options"
			v-model="value"
			@input="onSelected"
			placeholder="Please select">
		</v-select>
	</main>
</template>

<script>

export default {
	name: 'eia-select-question',

	model: {
		prop: 'valueProp',
		event: 'input',
	},

	props: {
		question: {
			type: Object,
			default: null,
		},
		valueProp: Object,
	},

	beforeMount(){

		this.emitCurrentStage();
		this.value = this.valueProp;

	},

	data() {
		return {
			value: null,
		};
	},

	computed: {

		options(){
			return this.question.answers;
		},

	},

	watch: {
		question(){
			this.emitCurrentStage();
		},
	},

	methods: {
		onSelected( value ) {
			this.$emit( 'input', value );
		},
		emitCurrentStage(){
			this.$emit( 'currentStage', {
				title: this.question.title,
				header: this.question.question,
			} );
		},
	},
};
</script>

<style lang="scss" scoped>
main {
	margin: 32px 0;
}
</style>
